import Anchor from "componets/atoms/anchor/anchor";
import { useNavigate } from "react-router-dom";
import "../../../styles/fontSizes.scss";
import Tag from "../../atoms/tag/tag";
import "./programCard.scss";
const ProgramCard = ({ programId, image, title, label, paragraph, link }) => {
  const navigateTo = useNavigate();
  return (
    <>
      <div className={`program-card__container font-size--2`}>
        <div className="program-card__image">
          <div className="program-card__image-content">
            <img src={image} alt="" className="program-card__image-content-1" />
            <img src={image} alt="" className="program-card__image-content-2" />
          </div>
        </div>

        <div className="program-card__title">{title}</div>

        <div className="program-card__label">
          {label ? (
            <Tag
              className={"program-card__label-text"}
              type={"posgrado"}
              textSize={1}
            />
          ) : (
            <Tag
              className={"program-card__label-text"}
              type={"pregrado"}
              textSize={1}
            />
          )}
        </div>

        <div className="program-card__paragraph">{paragraph}</div>

        <Anchor
          onClick={() => navigateTo("/programa/" + programId + "/perfil")}
          href={""}
          color={"black"}
          textSize={2}
          className={"program-card__link"}
        >
          Ver programa
        </Anchor>
      </div>
    </>
  );
};

export default ProgramCard;
